import { jsx as _jsx } from "react/jsx-runtime";
import { pathgen } from 'object-path-generator';
import { LoadingText } from 'seagull';
export const LoadingIndicatorTestIds = pathgen('LoadingIndicatorTestIds');
export default function LoadingIndicator(param) {
    let { testId = LoadingIndicatorTestIds.Root() } = param;
    return /*#__PURE__*/ _jsx(LoadingText, {
        testId: testId
    });
}
